"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var base_1 = __importDefault(require("./base"));
var errors_1 = require("@ledgerhq/errors");
var bjs = __importStar(require("bitcoinjs-lib"));
var base_2 = __importDefault(require("bs58check/base"));
var bs58check_1 = __importDefault(require("bs58check"));
var blake_hash_1 = __importDefault(require("blake-hash"));
var ripemd160_1 = __importDefault(require("ripemd160"));
var bs58_1 = __importDefault(require("bs58"));
var bip32_1 = __importDefault(require("./bip32"));
var Decred = /** @class */ (function (_super) {
    __extends(Decred, _super);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function Decred(_a) {
        var network = _a.network;
        var _this = _super.call(this, { network: network }) || this;
        _this.network.dustThreshold = 10000;
        _this.network.dustPolicy = "FIXED";
        _this.network.usesTimestampedTransaction = false;
        return _this;
    }
    Decred.blake256 = function (buffer) {
        var b = buffer;
        if (buffer instanceof Uint8Array) {
            b = Buffer.from(buffer);
        }
        return (0, blake_hash_1["default"])("blake256").update(b).digest();
    };
    // refer to decred spec https://devdocs.decred.org/developer-guides/addresses/
    Decred.getAddressFromPk = function (publicKey) {
        var prefix = Buffer.from("073f", "hex");
        var pkhash = Buffer.concat([
            prefix,
            new ripemd160_1["default"]().update(Decred.blake256(publicKey)).digest(),
        ]);
        var checksum = Decred._blake256x2(pkhash).slice(0, 4);
        return bs58_1["default"].encode(Buffer.concat([pkhash, checksum]));
    };
    Decred.prototype.toOutputScript = function (address) {
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        var decodeBase58 = Decred.bs58check.decode(address, Decred._blake256x2);
        var prefix = address.toLocaleUpperCase().substring(0, 2);
        if (prefix === "DC") {
            return bjs.payments.p2sh({ hash: decodeBase58.slice(2) })
                .output;
        }
        else if (prefix === "DE" || prefix === "DS") {
            return bjs.payments.p2pkh({ hash: decodeBase58.slice(2) })
                .output;
        }
        throw new errors_1.InvalidAddress();
    };
    // eslint-disable-next-line class-methods-use-this
    Decred.prototype.validateAddress = function (address) {
        if (address.length < 25 || address.length > 36) {
            return false;
        }
        try {
            Decred.bs58check.decode(address, Decred._blake256x2);
        }
        catch (error) {
            return false;
        }
        return true;
    };
    // get address given an address type
    Decred.prototype.customGetAddress = function (derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function () {
            var buffer, depth, i, chainCode, X, hd, publicKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        try {
                            buffer = Decred.bs58check.decode(xpub);
                        }
                        catch (_b) {
                            buffer = bs58check_1["default"].decode(xpub);
                        }
                        depth = buffer[4];
                        i = buffer.readUInt32BE(9);
                        chainCode = buffer.slice(13, 45);
                        X = buffer.slice(45, 78);
                        hd = new bip32_1["default"](X, chainCode, this.network, depth, i);
                        return [4 /*yield*/, hd.derive(account)];
                    case 1: return [4 /*yield*/, (_a.sent()).derive(index)];
                    case 2:
                        publicKey = (_a.sent())
                            .publicKey;
                        return [2 /*return*/, Decred.getAddressFromPk(publicKey)];
                }
            });
        });
    };
    Decred._blake256x2 = function (buffer) {
        return Decred.blake256(Decred.blake256(buffer));
    };
    Decred.bs58check = (0, base_2["default"])(Decred._blake256x2);
    return Decred;
}(base_1["default"]));
exports["default"] = Decred;
//# sourceMappingURL=decred.js.map